import { PRICE_DROP_SUPPRESSION_EXPERIMENT } from '~/constants/common/priceDropSuppression';
import useIsInExperiment from './useIsInExperiment';

export default function useIsInPriceDropSuppressionExperiment() {
  return useIsInExperiment(PRICE_DROP_SUPPRESSION_EXPERIMENT, 'treatment');
}
